import { render, staticRenderFns } from "./Enderecos.vue?vue&type=template&id=b220db86&scoped=true"
import script from "./Enderecos.vue?vue&type=script&lang=js"
export * from "./Enderecos.vue?vue&type=script&lang=js"
import style0 from "./Enderecos.vue?vue&type=style&index=0&id=b220db86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b220db86",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VBtn,VImg,VSkeletonLoader})
